var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import { Fodal } from "@costar/theme-ui-fodal";
import { Button, Flex } from "@costar/theme-ui";
var paneProps = { sx: { width: "1080px" } };
var contentProps = { sx: { "> iframe": { height: "calc(100vh - 190px)" } } };
var iframeStyle = { border: 0, width: "100%" };
var footerProps = {
    width: "100%",
    justifyContent: "flex-end",
    borderTop: "solid 1px #eaeaea",
    p: "0.7em",
};
var emptyFunction = function () {
    return;
};
export var TermsOfUse = function (props) {
    var acceptDeclineMode = props.acceptDeclineMode, _a = props.onAccept, onAccept = _a === void 0 ? emptyFunction : _a, _b = props.onCloseOrDecline, onCloseOrDecline = _b === void 0 ? emptyFunction : _b, termsOfUseUrl = props.termsOfUseUrl, _c = props.messages, ok = _c.ok, accept = _c.accept, decline = _c.decline;
    var modalProps = useMemo(function () { return ({
        open: true,
        onClose: onCloseOrDecline,
        id: "terms-of-use",
    }); }, [onCloseOrDecline]);
    var cardContent = useMemo(function () { return React.createElement("iframe", { "automation-id": "iframe-terms-of-use", src: termsOfUseUrl, style: iframeStyle }); }, [termsOfUseUrl]);
    var acceptDeclineButtons = useMemo(function () { return (React.createElement(Flex, __assign({}, footerProps),
        React.createElement(Button, { variant: "secondary", marginRight: "0.7em", onClick: onCloseOrDecline, "automation-id": "terms-of-use-cancel" }, decline),
        React.createElement(Button, { variant: "primary", onClick: onAccept, "automation-id": "terms-of-use-accept" }, accept))); }, [accept, decline, onAccept, onCloseOrDecline]);
    var okButton = useMemo(function () { return (React.createElement(Flex, __assign({}, footerProps),
        React.createElement(Button, { variant: "primary", onClick: onCloseOrDecline, "automation-id": "terms-of-use-ok" }, ok))); }, [ok, onCloseOrDecline]);
    return (React.createElement(Fodal, { modalProps: modalProps, paneProps: paneProps, cardContentProps: contentProps, cardContent: cardContent, cardFooter: acceptDeclineMode ? acceptDeclineButtons : okButton, "automation-id": "terms-of-use" }));
};
//# sourceMappingURL=terms-of-use.js.map